import blocks from './blocks';
import sections from './sections';
import components from './components';

// Email-mode block set: pre-built 600px "Sections" (the primary beginner content) + basic "rows",
// plus the `email-row` component type / row toolbar / "+" picker. Loaded only in Email mode; the other
// component TYPES (text/image/button/link) are still registered by the standard components() calls, so
// this markup resolves correctly. See DND_EMAIL_MODE_SPEC.md + DND_EMAIL_MODE_DND_PLACEMENT_REVIEW.
export default (editor, config) => {
  components(editor, config); // register the email-row type + reorder/add commands FIRST (needs baseUrl for the picker)
  sections(editor, { ...config, category: 'Sections' }); // pre-built 600px sections (shown first)
  blocks(editor, config); // basic single-purpose rows (category 'Basic')
};
